module.exports = __webpack_public_path__ + "media/images/menu/bootes-694dfa0395468c32b3d1d44a302aa022.jpg";